<section class="crud-shell">
  <div class="crud-header">
    <h1>{{ config.titulo }}</h1>

    <div class="crud-header__actions">
      <p-button label="Campos globales" icon="pi pi-list" severity="secondary" [outlined]="true" (click)="abrirCamposGlobales()" />
      <p-button label="Nuevo registro" icon="pi pi-plus" (click)="abrirNuevo()" />
    </div>
  </div>

  <div class="crud-card">
    <p-table [value]="items" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" responsiveLayout="scroll">
      <ng-template #header><tr><th *ngFor="let column of config.columns; trackBy: trackByLabel" [pSortableColumn]="column.key">{{ column.label }} <p-sort-icon [field]="column.key" /></th><th class="actions-col">Acciones</th></tr></ng-template>
      <ng-template #body let-item>
        <tr>
          <td *ngFor="let column of config.columns">
            <ng-container [ngSwitch]="column.type">
              <span *ngSwitchCase="'money'">S/. {{ formatearMoneda(item[column.key]) }}</span>
              <span *ngSwitchCase="'status'" class="campos-config-status" [class.campos-config-status--pending]="!item['camposConfigurados']">{{ item['camposConfigurados'] ? 'Configurado' : 'Configurar campos' }}</span>
              <ng-container *ngSwitchDefault>
                <span *ngIf="column.key === 'icono'" class="tipo-icono-preview">
                  <img *ngIf="item['icono'] || item['iconoUrl']" [src]="iconoPreview(item)" [alt]="'Icono de ' + item['descripcion']" />
                  <span *ngIf="!item['icono'] && !item['iconoUrl']">-</span>
                </span>
                <span *ngIf="column.key !== 'icono'">{{ getValorCelda(item, column.key) }}</span>
              </ng-container>
            </ng-container>
          </td>
          <td class="actions-col">
            <button type="button" class="icon-action icon-action--fields" (click)="abrirCampos(item)" title="Configurar campos" aria-label="Configurar campos"><i class="pi pi-list-check"></i></button>
            <button type="button" class="icon-action" (click)="editar(item)" title="Editar"><i class="pi pi-pencil"></i></button>
            <button type="button" class="icon-action icon-action--danger" (click)="confirmarEliminar(item)" title="Eliminar"><i class="pi pi-trash"></i></button>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage><tr><td [attr.colspan]="config.columns.length + 1" class="empty-state">No hay registros disponibles.</td></tr></ng-template>
    </p-table>
  </div>
</section>

<p-dialog
  [(visible)]="visibleDialog"
  [modal]="true"
  [draggable]="false"
  [closable]="!subiendoIcono"
  [style]="{ width: '42rem', maxWidth: '96vw' }"
  [header]="tituloDialogo"
>
  <div class="crud-form">
    <div class="crud-form__field" *ngFor="let field of config.fields">
      <label [for]="field.key === 'icono' ? 'tipo-vehiculo-icono' : field.key">{{ field.label }}</label>

      <ng-container [ngSwitch]="field.type">
        <input
          *ngSwitchCase="'text'"
          [id]="field.key"
          pInputText
          [(ngModel)]="registro[field.key]"
          [placeholder]="field.placeholder || field.label"
        />

        <input
          *ngSwitchCase="'number'"
          [id]="field.key"
          pInputText
          type="number"
          [(ngModel)]="registro[field.key]"
          [placeholder]="field.placeholder || field.label"
        />

        <input
          *ngSwitchCase="'decimal'"
          [id]="field.key"
          pInputText
          type="number"
          step="0.01"
          [(ngModel)]="registro[field.key]"
          [placeholder]="field.placeholder || field.label"
        />

        <ng-container *ngSwitchCase="'select'">
          <select
            *ngIf="field.key !== 'icono'"
            [id]="field.key"
            [(ngModel)]="registro[field.key]"
            class="crud-select"
          >
            <option [ngValue]="null">Selecciona una opción</option>
            <option *ngFor="let option of fieldOptions(field)" [ngValue]="option.id">
              {{ option.descripcion }}
            </option>
          </select>

          <button
            *ngIf="field.key === 'icono'"
            id="tipo-vehiculo-icono"
            type="button"
            class="tipo-icono-selector"
            [disabled]="guardando"
            (click)="abrirSelectorIconos()"
          >
            <span class="tipo-icono-selector__image">
              <img *ngIf="registro['icono'] || registro['iconoUrl']" [src]="iconoPreview(registro)" alt="" />
              <i *ngIf="!registro['icono'] && !registro['iconoUrl']" class="pi pi-plus" aria-hidden="true"></i>
            </span>
            <span class="tipo-icono-selector__text">
              <strong>{{ registro['icono'] || registro['iconoUrl'] ? 'Cambiar icono' : 'Agregar icono' }}</strong>
              <small>{{ registro['icono'] || registro['iconoUrl'] ? 'Toca la imagen para elegir otro' : 'Elige uno del catálogo o sube uno nuevo' }}</small>
            </span>
            <i class="pi pi-angle-right" aria-hidden="true"></i>
          </button>
        </ng-container>

        <label *ngSwitchCase="'checkbox'" class="checkbox-field">
          <input type="checkbox" [(ngModel)]="registro[field.key]" />
          <span>Registro activo</span>
        </label>
      </ng-container>
    </div>
  </div>

  <div class="crud-dialog-actions">
    <p-button
      label="Cancelar"
      severity="secondary"
      [outlined]="true"
      [disabled]="subiendoIcono"
      (click)="visibleDialog = false"
    />
    <p-button
      label="Guardar"
      icon="pi pi-check"
      [loading]="guardando"
      [disabled]="subiendoIcono"
      (click)="guardar()"
    />
  </div>
</p-dialog>

<p-dialog
  [(visible)]="visibleIconosDialog"
  [modal]="true"
  [draggable]="false"
  [closable]="!subiendoIcono"
  [closeOnEscape]="!subiendoIcono"
  [style]="{ width: '48rem', maxWidth: '96vw' }"
  [contentStyle]="{ maxHeight: '70vh', overflowY: 'auto' }"
  header="Seleccionar icono"
>
  <p class="tipo-iconos-modal__intro">Elige un icono para este tipo de vehículo o sube uno nuevo al catálogo.</p>
  <p class="tipo-iconos-modal__error" *ngIf="errorIconos">{{ errorIconos }}</p>
  <p class="tipo-iconos-modal__message" *ngIf="mensajeIconos">{{ mensajeIconos }}</p>
  <p *ngIf="cargandoIconos">Cargando iconos...</p>

  <input #iconoFileInput type="file" class="tipo-iconos-modal__file" accept="image/png,image/jpeg,image/webp" (change)="subirIcono($event)" />
  <div class="tipo-iconos-grid" *ngIf="!cargandoIconos">
    <button type="button" class="tipo-iconos-grid__item tipo-iconos-grid__item--upload" [disabled]="subiendoIcono" (click)="iconoFileInput.click()">
      <span class="tipo-iconos-grid__art"><i [class]="subiendoIcono ? 'pi pi-spin pi-spinner' : 'pi pi-plus'" aria-hidden="true"></i></span>
      <span>{{ subiendoIcono ? 'Subiendo...' : 'Subir nuevo' }}</span>
    </button>
    <button
      *ngFor="let icono of iconosCatalogo"
      type="button"
      class="tipo-iconos-grid__item"
      [class.tipo-iconos-grid__item--selected]="iconoSeleccionado(icono)"
      [attr.aria-pressed]="iconoSeleccionado(icono)"
      [disabled]="subiendoIcono"
      (click)="seleccionarIcono(icono)"
    >
      <span class="tipo-iconos-grid__art"><img [src]="iconoCatalogoPreview(icono)" [alt]="icono.nombre" /></span>
      <span>{{ icono.nombre }}</span>
    </button>
  </div>
  <small class="tipo-iconos-modal__hint">PNG, JPG o WEBP · 64–1024 px por lado · 512 bytes–1 MB.</small>
</p-dialog>

<p-dialog
  [(visible)]="visibleCamposGlobalesDialog"
  [modal]="true"
  [draggable]="false"
  [closable]="guardandoCampoGlobal === null"
  [style]="{ width: '75vw', maxWidth: '64rem', maxHeight: '90vh' }"
  [contentStyle]="{ overflowY: 'auto' }"
  styleClass="vehiculo-campos-globales-dialog"
>
  <ng-template #header>
    <div class="campos-modal-header">
      <span class="campos-modal-header__icon" aria-hidden="true"><i class="pi pi-list"></i></span>
      <div>
        <h2>Campos globales del vehículo</h2>
        <p>Oculta un campo en todos los tipos de vehículo. Sus datos y configuraciones se conservan.</p>
      </div>
    </div>
  </ng-template>

  <p class="campos-error" *ngIf="errorCamposGlobales">{{ errorCamposGlobales }}</p>
  <p class="campos-loading" *ngIf="cargandoCamposGlobales">Cargando campos...</p>

  <div class="campos-globales-search" *ngIf="!cargandoCamposGlobales">
    <i class="pi pi-search" aria-hidden="true"></i>
    <input pInputText type="search" aria-label="Buscar campo global" placeholder="Buscar por campo, código o control" [value]="busquedaCamposGlobales" (input)="filtrarCamposGlobales($any($event.target).value)" />
  </div>

  <p-table #tablaCamposGlobales *ngIf="!cargandoCamposGlobales" [value]="camposGlobales" [globalFilterFields]="['descripcion', 'codigo', 'tipoControl']" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" responsiveLayout="scroll">
    <ng-template #header>
      <tr>
        <th pSortableColumn="seccion">Sección <p-sort-icon field="seccion" /></th>
        <th pSortableColumn="descripcion">Campo <p-sort-icon field="descripcion" /></th>
        <th pSortableColumn="tipoControl">Control <p-sort-icon field="tipoControl" /></th>
        <th pSortableColumn="activo">Estado <p-sort-icon field="activo" /></th>
        <th class="actions-col">Acción</th>
      </tr>
    </ng-template>
    <ng-template #body let-campo>
      <tr>
        <td>{{ nombreSeccion(campo.seccion) }}</td>
        <td><strong>{{ campo.descripcion }}</strong><small class="campo-global__code">{{ campo.codigo }}</small></td>
        <td>{{ campo.tipoControl }}</td>
        <td><span class="campo-global__status" [class.campo-global__status--hidden]="campo.activo !== 1">{{ campo.activo === 1 ? 'Visible' : 'Oculto' }}</span></td>
        <td class="actions-col">
          <p-button
            [label]="campo.activo === 1 ? 'Ocultar' : 'Mostrar'"
            [icon]="campo.activo === 1 ? 'pi pi-eye-slash' : 'pi pi-eye'"
            [outlined]="true"
            [severity]="campo.activo === 1 ? 'secondary' : 'primary'"
            [loading]="guardandoCampoGlobal === campo.idCampo"
            [disabled]="guardandoCampoGlobal !== null"
            (click)="confirmarVisibilidadGlobal(campo)"
          />
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage><tr><td colspan="5" class="empty-state">No hay campos configurados.</td></tr></ng-template>
  </p-table>
</p-dialog>

<p-dialog
  [(visible)]="visibleCamposDialog"
  [modal]="true"
  [draggable]="false"
  [closable]="!guardandoCampos"
  [style]="{ width: '92vw', maxWidth: '96rem', maxHeight: '92vh' }"
  [contentStyle]="{ overflowY: 'auto' }"
  styleClass="vehiculo-campos-dialog"
>
  <ng-template #header>
    <div class="campos-modal-header">
      <span class="campos-modal-header__icon" aria-hidden="true"><i class="pi pi-truck"></i></span>
      <div>
        <h2>Campos de {{ tipoCampos?.['descripcion'] ?? 'vehículo' }}</h2>
        <p>Selecciona qué debe completar el usuario al registrar este tipo de vehículo. Los campos bloqueados están ocultos globalmente para todos los tipos de vehículo.</p>
      </div>
    </div>
  </ng-template>

  <p class="campos-error" *ngIf="errorCampos">{{ errorCampos }}</p>
  <p class="campos-loading" *ngIf="cargandoCampos">Cargando campos...</p>

  <div class="campos-grid" *ngIf="camposVehiculo.length && !cargandoCampos">
    <section class="campos-section" *ngFor="let seccion of seccionesCampos">
      <div class="campos-section__heading">
        <span class="campos-section__number">0{{ seccion.id }}</span>
        <h3>{{ seccion.titulo }}</h3>
        <span class="campos-section__count">{{ camposDeSeccion(seccion.id).length }} campos</span>
      </div>
      <div class="campos-row" *ngFor="let campo of camposDeSeccion(seccion.id)" [class.campos-row--global-hidden]="campo.activo !== 1">
        <div class="campos-row__info">
          <strong>{{ campo.descripcion }}</strong>
          <small>{{ campo.codigo }} · {{ campo.tipoControl }}</small>
          <span class="campos-row__global-note" *ngIf="campo.activo !== 1"><i class="pi pi-lock" aria-hidden="true"></i> Oculto globalmente</span>
        </div>
        <div class="campos-segmented" role="group" [attr.aria-label]="'Visibilidad de ' + campo.descripcion">
          <button type="button" class="campos-segmented__required" [class.is-selected]="campo.estado === 'OBLIGATORIO'" [attr.aria-pressed]="campo.estado === 'OBLIGATORIO'" [disabled]="campo.activo !== 1" (click)="campo.estado = 'OBLIGATORIO'">Obligatorio</button>
          <button type="button" [class.is-selected]="campo.estado === 'OPCIONAL'" [attr.aria-pressed]="campo.estado === 'OPCIONAL'" [disabled]="campo.activo !== 1" (click)="campo.estado = 'OPCIONAL'">Opcional</button>
          <button type="button" class="campos-segmented__hidden" [class.is-selected]="campo.estado === 'OCULTO'" [attr.aria-pressed]="campo.estado === 'OCULTO'" [disabled]="campo.activo !== 1" (click)="campo.estado = 'OCULTO'"><i class="pi pi-eye-slash" aria-hidden="true"></i>Oculto</button>
        </div>
      </div>
    </section>
  </div>

  <ng-template #footer>
    <div class="campos-modal-footer">
      <div class="campos-modal-footer__actions">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" [disabled]="guardandoCampos" (click)="visibleCamposDialog = false" />
        <p-button label="Guardar campos" icon="pi pi-check" [loading]="guardandoCampos" [disabled]="!camposVehiculo.length || cargandoCampos" (click)="guardarCampos()" />
      </div>
    </div>
  </ng-template>
</p-dialog>
